import { memo } from 'react';
import { Layout } from 'antd';
import SidebarMenu from './SidebarMenu';

// styles
import styles from './index.module.scss';

const { Sider } = Layout;

function Sidebar() {
  return (
    <Sider
      id='left-nav'
      className={styles.container}
      collapsedWidth='0'
      width={300}
    >
      <SidebarMenu />
    </Sider>
  );
}

export default memo(Sidebar);
